const newLang = {
  "Confirm Password": "암호 확인",
  "Next": "다음",
  "Please enter a four-digit password.": "암호 네자리를 입력해 주세요.",
  "That's the wrong password! Please re-enter.": "잘못된 암호네요! 다시 입력해 주세요.",
  "Enter Password": "암호 입력",
  "Please come back after checking.": "확인 후 다시 방문해 주세요.",
  "Please connect using the QR code.": "QR코드를 통해 접속해주세요",
  "Expired QR Code": "만료된 QR 코드입니다.",
  "Invalid access.": "질못된 접근입니다.",
  "An error has occurred.": "오류가 발생했습니다.",
  "Your data has been deleted.": "데이터가 삭제되었어요.",
  "Complete Setup": "설정 완료",
  "To protect your privacy, you'll need to agree to use it and set a password.": "개인 정보 보호를 위해 사용 동의와 비밀번호 설정이 필요해요.",
  "entry.button.set_password": "비밀번호 설정하기",
  "Consent is required to set a password.": "비밀번호를 설정하려면 동의가 필요합니다.",
  "I have received an explanation of the Ray Virtual Smile service by the hospital and understand the information provided.": "환자 본인은 병원으로부터 Ray Virtual Smile 서비스에 대한 설명을 듣고 제공되는 정보에 대하여 이해하였습니다.",
  "I have been given the opportunity by the hospital to ask questions about Ray Virtual Smile service.": "환자 본인은 병원에 Ray Virtual Smile 서비스에 대하여 충분히 질의하였습니다.",
  "I voluntarily agree the proposed use of data in sharing.": "환자 본인은 병원에 제공되는 데이터의 위탁에 동의하였습니다.",
  "I agree that managing this password is solely my responsible.": "환자 본인에게 비밀번호 관리의 의무가 있음에 동의합니다.",
  "I understand I can withdraw at any time without giving reasons and without being questioned, and that I will not be penalized for withdrawing.": "환자 본인은 병원을 통해 언제든지 불이익 없이 본 동의의 철회를 할 수 있습니다.",
  "Consent": "동의하기",
  "Set Password": "비밀번호 설정하기",
  "Please enter 4 numbers for your password.": "비밀번호 네 자리를 입력해 주세요.",
  "Confirm Password.": "한 번 더 입력해 주세요.",
  "Please enter your password again.": "비밀번호를 다시 입력해 주세요.",
  "Please wait for a moment.": "잠시만 기다려 주세요…",
  "Enter password": "비밀번호 입력",
  "Please enter your password.": "설정한 비밀번호를 입력해 주세요.",
  "The connection was rejected due to an abnormal access.": "올바른 접근이 아니에요.",
  "Setting": "설정",
  "Language": "언어",
  "Delete All Items": "모든 데이터 지우기",
  "Are you sure you want to delete? Erased data cannot be recovered.": "정말 지우시겠습니까? 한 번 지워진 데이터는 복구할 수 없습니다.",
  "Please enter your password to delete the data.": "데이터를 지우기 위해 비밀번호를 입력해 주세요.",
  "This data was deleted by requesting of user.": "고객님의 요청에 의해 삭제된 데이터 입니다.",
  "Make sure RAYTeams is logged in.": "RAYTeams가 로그인 상태인지 확인해 주세요.",
  "\"Ray Virtual Smile\" could not be found, please create new one.": "\"Ray Virtual Smile\" 정보를 확인할 수 없습니다. 새로 생성해 주세요.",
  "Data uploads are delayed due to poor network connectivity": "네트워크가 원활하지 않아 지연되고 있습니다.",
  "Confirm": "확인",
  "Delete": "삭제",
}

// const lang = {
//   "Hello": "안녕하세요.",
//   "This is Test {{type}}": "{{type}} 테스트 컴포넌트",
//   "Setting": "설정",
//   "Language": "언어",
//   "langs.ko": "한국어",
//   "langs.en": "영어",
//   "Terms and Conditions": "이용약관",
//   "Welcome!": "환영해요!",
//   "You have captured a 3D avatar.": "3D Avatar를 촬영하셨군요.",
//   "Shall we go and see my 3D avatar now?": "이제 나의 3D Avatar를 보러 갈까요?",
//   "To ensure the privacy of my precious personal Virtual Smile, password setup and agreement confirmation are essential requirements.": "소중한 나만의 Virtual Smile을 나만 볼 수 있게 암호 설정과 사용 동의가 꼭 필요해요.",
//   "Set Password": "암호 설정",
//   "Set password": "암호 설정하기",
//   "Confirm Password": "암호 확인",
//   "Next": "다음",
//   "Please enter a four-digit password.": "암호 네자리를 입력해 주세요.",
//   "Re-enter Password": "암호 재입력",
//   "Please enter the four-digit password again.": "암호 네 자리를 한 번 더 입력해 주세요.",
//   "Oh, the password is incorrect. Please try again.": "앗 암호가 올바르지 않아요. 다시 입력해 주세요.",
//   "Complete Setup and View Terms": "설정 완료하고 약관보기",
//   "To securely load my Virtual Smile, agreement confirmation and consent are required.": "나의 Virtual Smile을 안전하게 불러오기 위해 약관 확인과 동의가 필요해요.",
//   "Read the entire content": "약관을 모두 읽어주세요",
//   "Agree to the terms and conditions.": "약관에 동의",
//   "Please wait a moment!": "잠시만 기다려 주세요!",
//   "We are diligently loading your Virtual Smile.": "나의 Virtual Smile을 열심히 불러오고 있어요.",
//   "We are diligently loading your Virtual Smile. Please wait a moment!": "나의 Virtual Smile을 열심히 만들고 있어요. 잠시만 기다려 주세요!",
//   "Your Virtual Smile is perfectly ready. Shall we go watch it now?": "나의 Virtual Smile이 완벽하게 준비됐어요. 지금 바로 보러 갈까요?",
//   "Enter Password": "암호 입력",
//   "Enter password": "암호 입력하기",
//   "We're working on rendering Virtual Smile to show you!": "멋진 Virtual Smile을 불러오고 있어요!",
//   "Not the right approach.": "올바른 접근이 아니에요.",
//   "Please come back after checking.": "확인 후 다시 방문해 주세요.",
//   "Please connect using the QR code.": "QR코드를 통해 접속해주세요",
//   "My Virtual Smile is waiting for you right now.": "지금 나의 Virtual Smile이 기다리고 있어요.",
//   "Nice to see you again!": "다시 보게되어 반가워요!",
//   "Ta-da!": "짜잔!",
//   "Expired QR Code": "만료된 QR 코드입니다.",
//   "Invalid password.": "잘못된 비밀번호입니다.",
//   "Invalid access.": "질못된 접근입니다.",
//   "An error has occurred.": "오류가 발생했습니다.",
//   "Delete my data": "나의 데이터 삭제",
//   "To delete your data, please click the button below. Once deleted, the data cannot be recovered.": "데이터를 삭제하려면 아래 버튼을 클릭해주세요. 한번 삭제된 데이터는 복구가 불가능합니다.",
//   "A password confirmation is required for data deletion.": "데이터 삭제를 위해서 비밀번호 확인이 필요합니다.",
//   "Password Confirmation": "비밀번호 확인",
//   "Password Confirmation for Deletion": "데이터 삭제를 위한 비밀번호 확인",
//   "Cancel": "취소",
//   "Delete": "삭제",
//   "Your data has been deleted.": "데이터가 삭제되었어요.",
//   "To meet the new Virtual Smile, please request a new QR code.": "새로운 Virtual Smile을 만나 보시려면 QR코드를 다시 발부받아 주세요.",
//   "After entering the password, clicking the delete button will erase the data.": "비밀번호를 입력 후 삭제 버튼을 클릭하면 데이터가 삭제됩니다.",
//   "The deleted data cannot be recovered.": "삭제된 데이터는 복구할 수 없습니다.",
//   "Complete Setup": "설정 완료",
//   "You can set a password after agreeing to the following terms.": "다음 사항에 동의한 후에 비밀번호를 설정할 수 있습니다.",
//   "I have received an explanation of the Ray Virtual Smile service by the hospital and understand the information provided.": "환자 본인은 병원으로부터 Ray Virtual Smile 서비스에 대한 설명을 듣고 제공되는 정보에 대하여 이해하였습니다.",
//   "I have been given the opportunity by the hospital to ask questions about Ray Virtual Smile service.": "환자 본인은 병원에 Ray Virtual Smile 서비스에 대하여 충분히 질의하였습니다.",
//   "I voluntarily agree the proposed use of data in sharing.": "환자 본인은 병원에 제공되는 데이터의 위탁에 동의하였습니다.",
//   "I agree that managing this password is solely my responsible.": "환자 본인에게 비밀번호 관리의 의무가 있음에 동의합니다.",
//   "I understand I can withdraw at any time without giving reasons and without being questioned, and that I will not be penalized for withdrawing.": "환자 본인은 병원을 통해 언제든지 불이익 없이 본 동의의 철회를 할 수 있습니다.",
//   "Please review the information below.": "아래의 내용을 모두 확인해주세요.",
//   "You can set a password after agreeing.": "동의 후 비밀번호를 설정할 수 있어요.",
//   "Agree to All": "모두 동의하기",
//   "Waiting for a response": "응답을 기다리고 있어요",
//   "After agreeing to the following content, please set your password.": "아래 내용 동의 후, 암호를 설정해주세요.",
//   "Are you sure you want to delete? Once deleted, the data cannot be recovered.": "정말 삭제하시겠습니까? 한 번 삭제된 데이터는 복구가 불가능합니다.",
//   "Yes, confirmed.": "네, 확인했어요.",
//   "Please enter your password to proceed with data deletion.": "데이터 삭제를 위해 암호를 입력해주세요.",
//   "You've shot RAYFace. Shall we go and see Visual Smile now?": "RAYFace를 촬영하셨군요. 이제 나의 Virtual Smile을 보러 갈까요?",
//   "Create your Visual Smile for you.": "당신의 Visual Smile을 만들어 드릴께요.",
// };

// const trans = {
//   ...lang,
//   "To protect your privacy, you'll need to agree to use it and set a password.": "개인 정보 보호를 위해 사용 동의와 비밀번호 설정이 필요해요.",
//   "entry.button.set_password": "비밀번호 설정하기",
//   "Consent is required to set a password.": "비밀번호를 설정하려면 동의가 필요합니다.",
//   "I have received an explanation of the Ray Virtual Smile service by the hospital and understand the information provided.": "환자 본인은 병원으로부터 Ray Virtual Smile 서비스에 대한 설명을 듣고 제공되는 정보에 대하여 이해하였습니다.",
//   "I have been given the opportunity by the hospital to ask questions about Ray Virtual Smile service.": "환자 본인은 병원에 Ray Virtual Smile 서비스에 대하여 충분히 질의하였습니다.",
//   "I voluntarily agree the proposed use of data in sharing.": "환자 본인은 병원에 제공되는 데이터의 위탁에 동의하였습니다.",
//   "I agree that managing this password is solely my responsible.": "환자 본인에게 비밀번호 관리의 의무가 있음에 동의합니다.",
//   "I understand I can withdraw at any time without giving reasons and without being questioned, and that I will not be penalized for withdrawing.": "환자 본인은 병원을 통해 언제든지 불이익 없이 본 동의의 철회를 할 수 있습니다.",
//   "Consent": "동의하기",
//   "Set Password": "비밀번호 설정하기",
//   "Please enter 4 numbers for your password.": "비밀번호 네 자리를 입력해 주세요.",
//   "Confirm Password.": "한 번 더 입력해 주세요.",
//   "Please enter your password again.": "비밀번호를 다시 입력해 주세요.",
//   "Please wait for a moment.": "잠시만 기다려 주세요…",
//   "Enter password": "비밀번호 입력",
//   "Please enter your password.": "설정한 비밀번호를 입력해 주세요.",
//   "The connection was rejected due to an abnormal access.": "올바른 접근이 아니에요.",
//   "Setting": "설정",
//   "Language": "언어",
//   "Delete All Items": "모든 데이터 지우기",
//   "Are you sure you want to delete? Erased data cannot be recovered.": "정말 지우시겠습니까? 한 번 지워진 데이터는 복구할 수 없습니다.",
//   "Please enter your password to delete the data.": "데이터를 지우기 위해 비밀번호를 입력해 주세요.",
//   "This data was deleted by requesting of user.": "고객님의 요청에 의해 삭제된 데이터 입니다.",
//   "Make sure RAYTeams is logged in.": "RAYTeams가 로그인 상태인지 확인해 주세요.",
//   "\"Ray Virtual Smile\" could not be found, please create new one.": "\"Ray Virtual Smile\" 정보를 확인할 수 없습니다. 새로 생성해 주세요.",
//   "Data uploads are delayed due to poor network connectivity": "네트워크가 원활하지 않아 지연되고 있습니다.",
//   "Confirm": "확인",
//   "Delete": "삭제",
// }

export default newLang;

